module.exports = __webpack_public_path__ + "img/entrepenurial-start-project.520d7aec.jpg";